
import styles from "styles/LandingPage/careers.module.scss"
import StyledText from "../../typography/typography-component"
import { ReactNode } from "react"

export enum ChipType {
  RED = "red",
  GREEN = "green",
  BLUE = "blue",
}
function ChipComponent(props: { children: ReactNode; bgColor: string; color: string }) {
  const { bgColor, color: textColor } = props
  console.log(bgColor, textColor)
  return (
    <div style={{ backgroundColor: bgColor }} className={styles.chip}>
      <StyledText color={textColor} variant={"tags"}>
        {props.children}
      </StyledText>
    </div>
  )
}
export default ChipComponent